import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { extractToken } from '../color-conversion';
import { allHumanReadableColors } from '../constants';
export var createBuiltInColorMap = function createBuiltInColorMap(_ref) {
  var knownColors = _ref.knownColors,
    allColors = _ref.allColors,
    humanReadableColors = _ref.humanReadableColors,
    getResponsiveColor = _ref.getResponsiveColor;
  knownColors = knownColors.map(function (color) {
    return color.toLowerCase();
  });
  var knownTokens = knownColors.map(function (color) {
    return extractToken(color);
  });
  if (!allColors) {
    allColors = knownColors;
  } else {
    allColors = allColors.map(function (color) {
      return color.toLowerCase();
    });
  }
  var allTokens = allColors.map(function (color) {
    return extractToken(color);
  });
  var humanReadableColorsMap = humanReadableColors ? new Map([].concat(_toConsumableArray(allHumanReadableColors.entries()), _toConsumableArray(humanReadableColors.entries()))) : allHumanReadableColors;
  return {
    knownColors: knownColors,
    knownTokens: knownTokens,
    allColors: allColors,
    allTokens: allTokens,
    humanReadableColors: humanReadableColorsMap,
    getResponsiveColor: getResponsiveColor || function (color) {
      return color;
    }
  };
};